import { post } from '@/service/request';
const url = 'api/external/A3';

// 案件受理完成後繼續選擇其他保單
export function postInitContinue(data) {
    return post(`${url}/initContinue`, data);
}

export function postInitA6Continue(data) {
    return post('api/external/A6/initContinue', data);
}
